import { List } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

export const OverflowControlModal = ({
  waitingTime,
  setWaitingTime,
  callbackFunction
}: {
  waitingTime: number;
  setWaitingTime: Dispatch<SetStateAction<number>>;
  callbackFunction?: () => void;
}) => {
  const router = useRouter();
  const [remainTime, setRemainTime] = useState(waitingTime);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (remainTime < 0) {
      if (timer.current) {
        clearInterval(timer.current);
      }
      return;
    }
    timer.current = setInterval(() => {
      setRemainTime((prev) => prev - 1);
      if (remainTime === 0) {
        if (timer.current) {
          clearInterval(timer.current);
        }
        if (callbackFunction) {
          setWaitingTime(0);
          callbackFunction();
          return;
        }
        return;
      }
    }, 1000);

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, [callbackFunction, remainTime, router]);

  useEffect(() => {
    setRemainTime(waitingTime);
  }, [waitingTime]);

  return (
    <>
      {remainTime > 0 && (
        <div className={'fixed left-0 top-0 z-[110] flex h-full w-full items-end justify-center bg-[rgba(0,0,0,0.4)] sm:items-center'}>
          <div className={'relative m-[8px] w-full max-w-[440px] text-center overflow-hidden rounded-5 bg-white px-7 py-12'}>
            <div className={'mb-3 font-bold text-24 text-gray-900'}>홈택스 접속 대기중</div>
            <div className={'font-normal text-17 text-gray-700 whitespace-pre'}>{'현재 환급액 조회자가 많아서,\n잠시 대기 후 자동으로 접속할게요.'}</div>
            <List.Basic
              title={{
                text: `${remainTime}초`,
                color: 'red.700',
                badge: <img key={'waiting-time'} src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/ic-clock-md.svg`} alt={'clock icon'} />,
                titleStyle: 'headline-26 font-bold flex flex-row-reverse gap-1.5 justify-center reverse py-6'
              }}
            />
            <div className={'font-normal text-15 text-gray-600 whitespace-pre'}>{'*오후 7시 이후에 조회하면 더 원활한 진행 가능해요.'}</div>
            <div className={'font-normal text-15 text-gray-600 whitespace-pre'}>{'*새로고침 또는 재접속하면 대기가 더 길어져요.'}</div>
          </div>
        </div>
      )}
    </>
  );
};
